import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();

  const handleClick = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };
  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#1976d2", // Match the Sidebar's color (primary theme color)
        boxShadow: "none", // Optional: remove shadow for a flat look
      }}
    >
      <Toolbar>
        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            fontWeight: "bold",
            color: "#fff", // Ensure white text contrasts with the background
          }}
        >
          Admin Dashboard
        </Typography>
        {/* Logout Button */}
        <Button
          color="inherit"
          sx={{
            backgroundColor: "#fff",
            color: "#1976d2",
            textTransform: "none",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#e3f2fd",
            },
          }}
          onClick={handleClick}
        >
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
